import { useCallback, useMemo } from 'react';

import { useAnonymousIdSplitClient } from './useAnonymousIdSplitClient';
import { useUserIdSplitClient } from './useUserIdSplitClient';

import type { TrafficType } from '../types';

export type SplitClient = {
  client: SplitIO.IBrowserClient | null;
  isReady: boolean;
};

export function useGetSplitClient(): (trafficType: TrafficType) => SplitClient {
  const anonymousIdClient = useAnonymousIdSplitClient();
  const userIdClient = useUserIdSplitClient();

  const splitClients = useMemo(() => {
    return {
      anonymous: anonymousIdClient,
      user: userIdClient,
    };
  }, [anonymousIdClient, userIdClient]);

  return useCallback(
    (trafficType: TrafficType) => {
      return splitClients[trafficType];
    },
    [splitClients]
  );
}
